import filestack from '@atlas/tool/box/file/filestack';

export default function reuploadFile(url: string): Promise<string> {
    return filestack()
        .then((client) => client.storeURL(url))
        .then((result) => result.url);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('reuploadFile', async () => {
        it.todo('🤷');
    });
}

// #endregion
